export const WINDOW_BREAKPOINTS = {
  desktopMax: 1650,
  desktop: 1649.8,
  desktopMin: 1439.8,
  tabletMax: 1200,
  tablet: 1023.8,
  phoneMax: 767.8,
  phone: 465,
  phoneMin: 360,
} as const;

export const DEVICE_TYPE = {
  mobile: "mobile",
  tablet: "tablet",
  desktop: "desktop",
} as const;
